import { QUERY_PRESETS } from "@/queries/queryTimeConfig";

export const bookingAddonConfig = {
  /* ------------------------------- GET ---------------------------------- */

  getAllBookingAddons: {
    key: "getAllBookingAddons",
    url: "/api/v1/booking-addon-postings",
    method: "GET",
    options: {
      ...QUERY_PRESETS.LIST,
    },
  },

  getBookingsForAddon: {
    key: "getBookingsForAddon",
    url: "/api/v1/booking-addon-postings/bookings",
    method: "GET",
    options: {
      ...QUERY_PRESETS.LIST,
    },
  },

  getPropertyAddonsForAddon: {
    key: "getPropertyAddonsForAddon",
    url: "/api/v1/booking-addon-postings/property-addons",
    method: "GET",
    options: {
      ...QUERY_PRESETS.LIST,
    },
  },

  getBookingAddons: {
    key: "getBookingAddons",
    url: (data) => `/api/v1/booking-addon-postings/booking/${data.bookingId}`,
    method: "GET",
    options: {
      ...QUERY_PRESETS.DETAIL,
    },
  },

  getBookingsByDate: {
    key: "getBookingsByDate",
    url: "/api/v1/booking-addons/bookings-by-date",
    method: "GET",
    options: {
      ...QUERY_PRESETS.LIST,
    },
  },

  getBookingForAddon: {
    key: "getBookingForAddon",
    url: (params) => `/api/v1/bookings/number/${params.bookingNumber}`,
    method: "GET",
    options: {
      ...QUERY_PRESETS.DETAIL,
    },
  },

  /* ------------------------------- POST ---------------------------------- */

  createBookingAddon: {
    key: "createBookingAddon",
    url: "/api/v1/booking-addon-postings",
    method: "POST",
    options: {
      retry: 2,
      invalidateKeys: [
        "getAllBookingAddons",
        "getBookingAddons",
        "getBookingById",
      ],
      onSuccessMessage: "Addon added to booking successfully",
      onErrorMessage: "Failed to add addon to booking",
    },
  },

  createBookingAddonByBookingNumber: {
    key: "createBookingAddonByBookingNumber",
    url: "/api/v1/booking-addons/by-booking-number",
    method: "POST",
    options: {
      retry: 2,
      invalidateKeys: [
        "getAllBookingAddons",
        "getBookingAddons",
        "getBookingById",
      ],
      onSuccessMessage: "Special request created successfully",
      onErrorMessage: "Failed to create special request",
    },
  },

  approveSpecialRequest: {
    key: "approveSpecialRequest",
    url: (data) => `/api/v1/booking-addon-postings/${data.itemId || data.id}/approve`,
    method: "POST",
    options: {
      retry: 2,
      invalidateKeys: [
        "getAllBookingAddons",
        "getBookingAddons",
        "getBookingById",
        "getBookingByNumber",
        "getSelectedServicesStatus",
      ],
      onSuccessMessage: "Addon approved successfully",
      onErrorMessage: "Failed to approve addon",
    },
  },

  rejectSpecialRequest: {
    key: "rejectSpecialRequest",
    url: (data) => `/api/v1/booking-addon-postings/${data.itemId || data.id}/reject`,
    method: "POST",
    options: {
      retry: 2,
      invalidateKeys: [
        "getAllBookingAddons",
        "getBookingAddons",
        "getBookingById",
        "getBookingByNumber",
        "getSelectedServicesStatus",
      ],
      onSuccessMessage: "Addon rejected successfully",
      onErrorMessage: "Failed to reject addon",
    },
  },

  /* ------------------------------- PUT ---------------------------------- */

  updateBookingAddon: {
    key: "updateBookingAddon",
    url: (data) => `/api/v1/booking-addons/${data.id}`,
    method: "PUT",
    options: {
      retry: 2,
      invalidateKeys: [
        "getAllBookingAddons",
        "getBookingAddons",
        "getBookingById",
      ],
      onSuccessMessage: "Addon updated successfully",
      onErrorMessage: "Failed to update addon",
    },
  },

  /* ------------------------------- DELETE ---------------------------------- */

  deleteBookingAddon: {
    key: "deleteBookingAddon",
    url: (data) => `/api/v1/booking-addons/${data.id}`,
    method: "DELETE",
    options: {
      retry: 2,
      invalidateKeys: [
        "getAllBookingAddons",
        "getBookingAddons",
        "getBookingById",
      ],
      onSuccessMessage: "Addon removed successfully",
      onErrorMessage: "Failed to remove addon",
    },
  },
};
